import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bubble-line',
    templateUrl: './bubble-line.component.html',
    styleUrls: ['./bubble-line.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BubbleLineComponent {
  @Input() current: any;
  @Input() items: any[];
  @Input() notActive: boolean = false;
  @Input() readOnly: boolean = false;
  @Input() scaling: boolean = false;
  @Output() moveStatus = new EventEmitter();
  onClick(item: any) {
    if (!this.readOnly && !this.notActive) {
      this.moveStatus.emit(item);
    }
  }
}
